/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoBranding = exports.AccountStatus = void 0;
var AccountStatus;
(function (AccountStatus) {
    AccountStatus["ACTIVE"] = "ACTIVE";
    AccountStatus["BLOCKED"] = "BLOCKED";
    AccountStatus["DELETED"] = "DELETED";
})(AccountStatus = exports.AccountStatus || (exports.AccountStatus = {}));
var CoBranding;
(function (CoBranding) {
    CoBranding["None"] = "None";
    CoBranding["CoBranded"] = "CoBranded";
    CoBranding["CoBranded_Customer_New"] = "CoBranded_Customer_New";
    CoBranding["CoBranded_Customer_Existing"] = "CoBranded_Customer_Existing";
})(CoBranding = exports.CoBranding || (exports.CoBranding = {}));
//# sourceMappingURL=types.js.map